import React from 'react';
import ToggleComponent from "v4/components/utils/ToggleComponent/ToggleComponent";
import {SearchProvider} from "v4/contexts/SearchContext/SearchContext";
import {TASK_SEARCH} from "v4/data/apiRoutes";
import TasksListing from "v4/pages/front/Tasks/components/TasksListing/TasksListing";
import useHashPulse from "v4/hooks/useHashPulse";

export default function TasksPage() {
    useHashPulse(true);

    return (
        <SearchProvider searchRouteName={TASK_SEARCH} pageType="tasks">
            <ToggleComponent isShowing={true} className="page page-list main-content__body__slide">
                <TasksListing />
            </ToggleComponent>
        </SearchProvider>
    );
}
